<template>
  <DefaultLayout>
    <div class="self-center flex-1 text-gray-800 text-center text-brand-green">
      <h2 class="mb-10 text-3xl font-heading">Github Authentication</h2>
      <h2 class="mb-10 font-bold">Login with Github to start your 7 day free trial.</h2>
      <div class="mb-10">You can cancel the trial at any point before the 7 days ends and you won’t be charged. We will even remind you 1 day before. </div>
        <div v-if="user">
        <img :src="user.avatar" />
        {{ user.username }}

      </div>
    </div>
  </DefaultLayout>
</template>

<script>
import DefaultLayout from '@/components/layouts/DefaultLayout.vue'

export default {
  name: 'GithubAuth',
  components: {
    DefaultLayout
  },
  async created () {
    const authCode = this.$route.query.code
    await this.$store.dispatch('login', { authCode })
    this.$router.push('/')
  },
  computed: {
    user () {
      return this.$store.state.user
    }
  }
}
</script>

<style scoped lang="scss">

</style>
